import * as core from './core'
import { CliClient } from '../rpc'
import { ec as EC } from 'elliptic'

class StealthAccount {
  constructor (str = null) {
    if (!str) {
      this.payloadPrikey = core.generatePrivateKey()
      this.payloadPubkey = core.getPublicKeyFromPrivateKey(this.payloadPrikey)
      this.address = ''
    } else if (typeof str === 'object') {
      this.payloadPrikey = str.payloadPrikey
      this.payloadPubkey = str.payloadPubkey
      this.viewPrikey = str.viewPrikey
      this.viewPubkey = str.viewPubkey
      this.address = str.address
    } else {
      throw new ReferenceError(`Invalid input: ${str}`)
    }
  }

  /** initialize viewingkey, receivingkey, address with spendingkey */
  init (net) {
    const cliClient = new CliClient(net)

    return cliClient.getOneTimePubkey()
      .then((res) => {
        if (res === '') throw new Error('Initialization failed!')

        var serverPubkey = res
        var keypair = new EC('p256').genKeyPair()
        var cipher = core.processEncrypt(this.payloadPrikey, keypair.getPrivate('hex'), serverPubkey)

        return cliClient.createStealthWallet(cipher)
          .then((res) => {
            if (res === undefined) throw new Error('Initialization failed!')
            var ret = core.processDecrypt(res, keypair.getPrivate('hex'))

            this.address = ret.address
            this.viewPrikey = ret.viewkey
            this.viewPubkey = core.getPublicKeyFromPrivateKey(this.viewPrikey)
            return true
          })
      })
  }

  /** get anonymous wallet balance */
  getBalance (net) {
    if (this.address === undefined || this.payloadPrikey === undefined) {
      throw new Error('Please initialize the wallet.')
    }

    const cliClient = new CliClient(net)

    return cliClient.getOneTimePubkey()
      .then((res) => {
        if (res === '') throw new Error('Initialization failed!')

        var request = {
          address: this.address,
          privatekey: this.payloadPrikey
        }

        var serverPubkey = res
        var keypair = new EC('p256').genKeyPair()
        var cipher = core.processEncrypt(JSON.stringify(request), keypair.getPrivate('hex'), serverPubkey)

        return cliClient.getPrivateBalance(cipher)
          .then((res) => {
            try {
              if (res === undefined) throw new Error('Getting balance failed!')

              var ret = core.processDecrypt(res, keypair.getPrivate('hex'))

              return ret
            } catch (err) {
              throw new Error('Getting balance failed!')
            }
          })
      })
  }

  /** get anonymous wallet balance */
  getTransactionHistory (net) {
    if (this.address === undefined || this.payloadPrikey === undefined) {
      throw new Error('Please initialize the wallet.')
    }

    const cliClient = new CliClient(net)

    return cliClient.getOneTimePubkey()
      .then((res) => {
        if (res === '') throw new Error('Initialization failed!')

        var request = {
          address: this.address,
          privatekey: this.payloadPrikey
        }

        var serverPubkey = res
        var keypair = new EC('p256').genKeyPair()
        var cipher = core.processEncrypt(JSON.stringify(request), keypair.getPrivate('hex'), serverPubkey)

        return cliClient.getPrivateTransactionHistory(cipher)
          .then((res) => {
            try {
              if (res === undefined) throw new Error('Getting balance failed!')

              var ret = core.processDecrypt(res, keypair.getPrivate('hex'))

              return ret
            } catch (err) {
              throw new Error('Getting balance failed!')
            }
          })
      })
  }

  /** send private tx */
  sendPrivateTx (net, toAddress, assetId, amount) {
    if (this.address === undefined || this.payloadPrikey === undefined) {
      throw new Error('Please initialize the wallet.')
    }

    const cliClient = new CliClient(net)

    return cliClient.getOneTimePubkey()
      .then((res) => {
        if (res === '') throw new Error('Initialization failed!')

        var request = {
          address: this.address,
          to_address: toAddress,
          assetId: assetId,
          amount: amount,
          privatekey: this.payloadPrikey
        }

        var serverPubkey = res
        var keypair = new EC('p256').genKeyPair()
        var cipher = core.processEncrypt(JSON.stringify(request), keypair.getPrivate('hex'), serverPubkey)

        return cliClient.sendPrivateTx(cipher)
          .then((res) => {
            try {
              if (res === undefined) throw new Error('Sending private tx failed!')

              var ret = core.processDecrypt(res, keypair.getPrivate('hex'))

              return ret
            } catch (err) {
              throw new Error('Sending private tx failed!')
            }
          })
      })
  }

  /** rebuild wallet */
  rebuildWallet (net) {
    if (this.address === undefined || this.spendingKey === undefined) {
      throw new Error('Please initialize the wallet.')
    }

    const cliClient = new CliClient(net)

    return cliClient.getOneTimePubkey()
      .then((res) => {
        if (res === '') throw new Error('Initialization failed!')

        var request = {
          address: this.address,
          privatekey: this.payloadPrikey
        }

        var serverPubkey = res
        var keypair = new EC('p256').genKeyPair()
        var cipher = core.processEncrypt(JSON.stringify(request), keypair.getPrivate('hex'), serverPubkey)

        return cliClient.rebuildWallet(cipher)
          .then((res) => {
            try {
              if (res === undefined) throw new Error('Rebuilding wallet failed!')

              var ret = core.processDecrypt(res, keypair.getPrivate('hex'))

              return ret
            } catch (err) {
              throw new Error('Rebuilding wallet failed!')
            }
          })
      })
  }
}

export default StealthAccount
